<template>
    <div>
        <form @submit.prevent="submitForm">
            <input type="hidden" v-model="id"/>
            <div class="form-group">
                <label class="form-label">{{$t('label.title')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-text"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">{{$t('label.category')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-folder-open"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.category')" v-model="category" required="">
                </div>
            </div>
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="enable" v-model="enable">
                <label class="custom-control-label" for="enable">{{$t('label.enable')}}</label>
            </div>
            <div class="text-left border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnChecklist">{{$t('button_link.cancel')}}</button>
                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                    <div class="d-none col-6 text-right">
                        <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed">{{$t('button_link.delete')}}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: 'checklistForm',
    props: {
        isEdit: { type: Boolean }
    },
    data(){
        return{
            id: 0, title: "", category: "", enable: 0
        }
    },
    methods:{
        editChecklistDetails(item){
            this.id = item.checkListID;
            this.title = item.title;
            this.category = item.category;
            this.enable = item.isEnable;
        },
        submitForm(){
            var data = {
                title: this.title,
                category: this.category,
                isEnable: this.enable ? 1 : 0
            }
            this.$emit('submitForm', data);
        },
        returnChecklist(){
            this.$emit('returnChecklist', false)
        },
        deleteCheckList(){
            this.$emit('deleteCheckList', this.id, this.title)
        }
    }
}
</script>